/** Format 32-char hex as Notion UUID. */
function formatNotionId(hex: string): string {
  const h = hex.toLowerCase();
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** Parse a Notion page id from a URL, UUID, or bare hex id. */
export function parseNotionPageId(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;

  const uuidMatch = trimmed.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  );
  if (uuidMatch) return uuidMatch[0].toLowerCase();

  const hex32 = trimmed.match(/^[0-9a-f]{32}$/i);
  if (hex32) return formatNotionId(hex32[0]);

  try {
    const url = new URL(
      trimmed.startsWith("http") ? trimmed : `https://${trimmed}`,
    );
    const last = url.pathname.split("/").filter(Boolean).pop() ?? "";
    const idPart = last.replace(/-/g, "").slice(-32);
    if (/^[0-9a-f]{32}$/i.test(idPart)) {
      return formatNotionId(idPart);
    }
  } catch {
    // not a URL
  }

  return null;
}
